import { SellerBidListingForm } from "../../components/seller/SellerBidListingForm";
import { AuthHelper } from '../../utils/auth_helper';
import { SellerMenuTab } from '../../components/seller/SellerMenuTab'

import React from "react";
import Grid from '@mui/material/Grid';


function SellerBidListing() {

  return (
    <div>
    <AuthHelper />
    <SellerMenuTab/>

      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">
          
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Seller Bid Listing</p></span>
              </Grid>
            </Grid>

            <SellerBidListingForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerBidListing };
